<template>
  <div class="page">
    <div class="card">
      <div class="topbar">
        <div>
          <h1 class="title">Submissoes de relatorios</h1>
          <p class="subtitle">Relatorios diarios e incidentes registrados.</p>
        </div>
        <div class="topbar-right">
          <span class="pill">{{ roleLabel }}</span>
          <button class="btn btn-ghost" type="button" @click="goHome">Inicio</button>
          <button class="btn btn-ghost" type="button" @click="goToAdmin" v-if="isAdmin">
            Ir para admin
          </button>
          <button class="btn btn-ghost" type="button" @click="logout">Sair</button>
          <button class="icon-btn" type="button" @click="create">+</button>
        </div>
      </div>

      <div v-if="items.length === 0" class="item-card">
        <h3 class="item-title">Nenhuma submissao por aqui</h3>
        <p class="item-meta">Clique no + para criar o primeiro relatorio.</p>
      </div>

      <div v-else class="grid card-list">
        <div v-for="item in items" :key="item.id" class="item-card">
          <div>
            <h3 class="item-title">
              {{ item.title }} - {{ item.attraction }} - {{ formatReportDate(item.reportDate) }}
            </h3>
            <div class="item-meta">
              {{ formatDate(item.createdAt) }} - {{ item.status === 'rascunho' ? 'Rascunho' : 'Enviado' }}
            </div>
          </div>
          <div class="actions">
            <button class="btn btn-secondary" type="button" @click="view(item.id)">Visualizar</button>
            <button class="btn btn-ghost" type="button" @click="edit(item.id)">Editar</button>
            <button class="btn btn-accent" type="button" @click="remove(item.id)">Excluir</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { sessionStore } from '@/store/session'
import { submissionsStore } from '@/store/submissions'
import { formatDateOnly, formatDateTime } from '@/utils/date'
import { uiStore } from '@/store/ui'

export default defineComponent({
  name: 'SubmissionsView',
  setup() {
    const router = useRouter()
    const user = computed(() => sessionStore.state.user)
    const isAdmin = computed(() => sessionStore.isAdmin.value)

    const reportTypes = ['Relatorio diario de obra', 'Relatorio de incidente']

    const items = computed(() => {
      if (!user.value) return []
      const all = submissionsStore.all().filter((item) => reportTypes.includes(item.title))
      if (user.value.role === 'admin-master' || user.value.role === 'admin-obra') {
        return all
      }
      return all.filter((item) => item.author.name === user.value?.name)
    })

    const roleLabel = computed(() => (isAdmin.value ? 'Administrador' : 'Usuario comum'))

    const create = () => router.push('/submission/new')
    const view = (id: string) => router.push(`/submission/${id}`)
    const edit = (id: string) => router.push(`/submission/${id}/edit`)

    const remove = async (id: string) => {
      if (!await uiStore.confirm('Excluir esta submissao?')) return
      await submissionsStore.deleteSubmission(id)
    }

    const logout = () => {
      sessionStore.logout()
      router.push('/login')
    }

    const goToAdmin = () => {
      router.push('/admin/reports')
    }

    const goHome = () => {
      router.push('/home')
    }

    onMounted(() => {
      submissionsStore.refresh().catch(() => {
        // ignore for now
      })
    })

    return {
      items,
      formatDate: formatDateTime,
      formatReportDate: formatDateOnly,
      create,
      view,
      edit,
      remove,
      logout,
      roleLabel,
      isAdmin,
      goToAdmin,
      goHome
    }
  }
})
</script>
